import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getFilteredEvents } from '../actions';
import { Global_ISDA_Functions } from 'Root/global/global';

class EventSelectorFeatured extends Component {
	constructor( props ) {
		super( props );
	}

	renderFeaturedEvents() {
		function renderRegistrationLink( event ) {
			if ( event.registration === true ) {
				return (
					<a href={ event.registration_url } className="btn btn-default" data-imiscode={event.imis_code}>
						Register Now
						<span className="sr-only"> for { event.title }</span>
					</a>
				);
			}

			return null;
		}

		let globalIsdaFunctions = new Global_ISDA_Functions();
		let unfilteredEvents = getFilteredEvents( '', '', '', this.props.events );
		let loadedState = globalIsdaFunctions.vanillaHasClass( document.querySelector( '.react-fallback' ), 'loaded' );
		let i = 0;

		if ( Array.isArray( unfilteredEvents ) && unfilteredEvents.length && loadedState === true ) {
			return unfilteredEvents.map( ( event, ind ) => {
				i = i + 1;
				//loaded post loop
				return (
						<div>
							{ event.is_featured ? (
								<div>
									{ i===1 ? (
										<h2 className="featured-title"><span>Featured</span></h2>
									) : ('') }
										<div key={ ind } className="events-post" data-region={ event.region }>
											<div className="events-post-img-wrap">
													<a href={ event.link } data-imiscode={event.imis_code}>
														<img src={ event.thumbnail } className="event-venue-thumbnail" alt="" role="presentation" width="336" height="297" />
													</a>
											</div>
											<div className="events-post-content">
												<p className={ event.formatted_date ? "events-post-date" : "events-post-date empty-spacing" }>{ event.formatted_date }</p>
												<p className={event.city.name ? "events-post-location" : "events-post-location empty-spacing"}>
														{ ! event.is_hybrid ? (
															<a href={event.city_link}>{event.city.name}</a>
														) : (
															<a href={event.city_link}>{event.city.name}/Online</a>
														)}
												</p>
												<h2 className="events-post-title">
														<a href={ event.link } data-imiscode={event.imis_code}>
																{ event.title }
														</a>
												</h2>
												<a href={ event.link } className="btn btn-default" data-imiscode={event.imis_code}>
														Event Details
														<span className="sr-only"> for { event.title }</span>
												</a>
												{ renderRegistrationLink( event ) }
											</div>
										</div>
								</div>
							) : ('')}
						</div>
				);
			} );
		}
	}

	getEmptyEvent() {
		return (
				<div className="events-post">
					<div className="events-post-img-wrap">
						<a href="">
						<span className="event-venue-thumbnail placeholder" width="336" height="297" />
						</a>
					</div>
					<div className="events-post-content">
						<p className="events-post-date">&nbsp;</p>
						<p className="events-post-location">&nbsp;</p>
						<h3 className="events-post-title">&nbsp;</h3>
						<a href="" className="btn btn-default">
						&nbsp;
						</a>
						<a href="" className="btn btn-default">
							&nbsp;
						</a>
					</div>
				</div>
		);
	}

	render() {
		return (
				<div className="events-posts-list magazine">
					<div id="events-magazine" className="custom-tab-wrapper">
						<div className="events-post-list">
							{ this.renderFeaturedEvents() }
						</div>
					</div>
				</div>
		);
	}
}

function mapStateToProps( { events } ) {
	return { events };
}

export default connect( mapStateToProps, null )( EventSelectorFeatured );
